<template>
  <div>
    申请定制缩水软件（众筹）
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>